/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Emailnotset2Inputs */

const zh_password_emailnotset2 = /** @type {(inputs: Password_Emailnotset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱未设置`)
};

const en_password_emailnotset2 = /** @type {(inputs: Password_Emailnotset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email not set`)
};

const es_password_emailnotset2 = /** @type {(inputs: Password_Emailnotset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo no configurado`)
};

/**
* | output |
* | --- |
* | "Email not set" |
*
* @param {Password_Emailnotset2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const password_emailnotset2 = /** @type {((inputs?: Password_Emailnotset2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Emailnotset2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_password_emailnotset2(inputs)
	if (locale === "en") return en_password_emailnotset2(inputs)
	return es_password_emailnotset2(inputs)
});
export { password_emailnotset2 as "password_emailNotSet" }